
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sa/2024/agenda",
      function () {
        return require("private-next-pages/sa/2024/agenda.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sa/2024/agenda"])
      });
    }
  